import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { TextField } from "@mui/material";
import request from "../services/Request";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "./items/AuthProvider";
import Swal from "sweetalert2";

const SignUpPage = () => {
  const navigate = useNavigate();

  const { company } = useParams();
  const { setLoading } = useAuth();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    name: "",
    email: "",
    password: "",
    p2: "",
    phone: "",
  });

  const watchall = watch();

  const handleSignUp = (formData) => {
    setLoading(true);
    // return console.log("formData", formData);
    request({
      method: "post",
      url: `/signupClientUser`,
      data: {
        username: formData.name,
        email: formData.email,
        password: formData.password,
        phone: formData.phone,
        company: company,
      },
    })
      .then((res) => {
        // Swal.fire({
        //   text: res.data.message,
        //   icon: "success",
        // });
        navigate(`/login/${company}`);
      })
      .catch((err) => {
        console.log(err.response);
        Swal.fire({
          text: err.response?.data?.error?.message || "Something went wrong",
          icon: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    company !== "undefined" && (
      <div className="flex justify-center items-center h-screen">
        <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
          <h2 className="text-2xl font-bold mb-4 text-center">Sign Up</h2>
          <form onSubmit={handleSubmit(handleSignUp)}>
            <div className="mb-4">
              <TextField
                label="Name"
                fullWidth
                required
                {...register("name", { required: "Name is required" })}
              />
            </div>
            <div className="mb-4">
              <TextField
                label="Email"
                type="email"
                fullWidth
                required
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value:
                      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                    message: "Please enter a valid email",
                  },
                })}
              />
            </div>
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}
            <div className="mb-4">
              <TextField
                label="Phone Number (optional)"
                fullWidth
                {...register("phone", {
                  // Optional, but still validated when something is entered
                  pattern: {
                    value:
                      /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                    message: "Please enter a valid phone number",
                  },
                })}
              />
            </div>
            {errors.phone && (
              <p className="text-red-500 text-sm">{errors.phone.message}</p>
            )}
            <div className="mb-4">
              <TextField
                label="Password"
                type="password"
                fullWidth
                required
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be longer than 8 characters",
                  },
                })}
              />
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.password.message}
                </p>
              )}
            </div>
            <div className="mb-4">
              <TextField
                label="Password Confirmation"
                type="password"
                fullWidth
                required
                {...register("p2", {
                  required: "Password confirmation is required",
                  minLength: {
                    value: 8,
                    message: "Password must be longer than 8 characters",
                  },
                  validate: (value) =>
                    value === watchall?.password ||
                    "The passwords do not match",
                })}
              />
              {errors.p2 && (
                <p className="text-red-500 text-sm">{errors.p2.message}</p>
              )}
            </div>
            <div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Sign Up
              </Button>
            </div>
          </form>
          <p className="mt-4 text-center">
            Already have an account?{" "}
            <Link
              to={`/login/${company}`}
              className="text-blue-500 hover:text-blue-700"
            >
              Login
            </Link>
          </p>
        </div>
      </div>
    )
  );
};

export default SignUpPage;
